import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { isDefined } from '@fi-shared/utils';
import { FiItemsListOptionType } from '@fi-shared/fi-items-list/fi-items-list-option-type';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';

@Component({
    selector: 'fi-mat-icon-checkbox-menu-item',
    templateUrl: './fi-mat-icon-checkbox-menu-item.component.html',
    styleUrl: './fi-mat-icon-checkbox-menu-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-mat-icon-checkbox-menu-item' },
    standalone: false,
})
export class FiMatIconCheckboxMenuItemComponent<T extends any> {
    @Input({ required: true }) value: T;
    @Input({ required: true }) action: IItemsListAction2;
    @Input() menuClass: string = '';

    protected isMatMenuItemDisabled(action: IItemsListAction2): boolean {
        return isDefined(action.disabled) ? action.disabled(this.value) : false;
    }

    protected isMatMenuItemShown(subAction: IItemsListAction2): boolean {
        return isDefined(subAction.condition) ? subAction.condition(this.value) : true;
    }

    protected getOptionType(action: IItemsListAction2): FiItemsListOptionType {
        return action.optionType ?? FiItemsListOptionType.Common;
    }

    protected onMenuItemClicked(action: IItemsListAction2, $event: MouseEvent) {
        if (this.getOptionType(action) === FiItemsListOptionType.Checkbox) {
            $event.stopPropagation();
        }
        action.onClick(this.value);
    }

    protected hasSubActions(action: IItemsListAction2): boolean {
        return action.subActions?.length > 0;
    }

    protected readonly FiItemsListOptionType = FiItemsListOptionType;
    protected readonly FiInfoIconMode = FiInfoIconMode;
}
